import { ReactEditor } from 'slate-react';
import { isDOMNode } from './isDOMNode.mjs';

/**
 * Check if the target is within the editor.
 */

function hasTarget(editor, target, options) {
  return isDOMNode(target) && ReactEditor.hasDOMNode(editor, target, options);
}

export { hasTarget };
